/* Plyconcept theme.js — vanilla, no dependencies */
(function () {
  'use strict';

  var ROUTES = {};
  try {
    var el = document.getElementById('ThemeRoutes');
    if (el) ROUTES = JSON.parse(el.textContent);
  } catch (e) {}

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var money = function (cents) {
    var fmt = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'AED';
    return fmt + ' ' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    var scrim = document.getElementById('DrawerScrim');
    if (!drawer || !scrim) return;
    function open() {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('a,button');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = n;
      if (n > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
    });
  }

  /* ---------- product gallery ----------
     One horizontal scroll-snap track. Swipe works natively with no JavaScript at all;
     JS only adds the thumbnails, the arrows and the counter. Nothing is ever cropped —
     the customer is judging the object, so the slide letterboxes rather than cuts. */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var track = root.querySelector('[data-pg-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pg-slide]'));
      if (slides.length < 1) return;
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pg-thumb]'));
      var thumbRail = root.querySelector('[data-pg-thumbs]');
      var counter = root.querySelector('[data-pg-count]');
      var prev = root.querySelector('[data-pg-prev]');
      var next = root.querySelector('[data-pg-next]');
      var index = 0;
      var origin = slides[0].offsetLeft;

      function paint(i) {
        index = i;
        thumbs.forEach(function (t, n) {
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        if (thumbRail && thumbs[i]) {
          var t = thumbs[i];
          var left = t.offsetLeft - thumbRail.offsetLeft;
          var right = left + t.offsetWidth;
          if (left < thumbRail.scrollLeft) thumbRail.scrollLeft = left - 8;
          else if (right > thumbRail.scrollLeft + thumbRail.clientWidth) {
            thumbRail.scrollLeft = right - thumbRail.clientWidth + 8;
          }
        }
      }

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        origin = slides[0].offsetLeft;
        var left = slides[i].offsetLeft - origin;
        if (track.scrollTo) track.scrollTo({ left: left, behavior: REDUCED ? 'auto' : 'smooth' });
        else track.scrollLeft = left;
        paint(i);
      }

      // Keep the active state honest when the customer swipes rather than clicks.
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = window.requestAnimationFrame(function () {
          tick = null;
          origin = slides[0].offsetLeft;
          var pos = track.scrollLeft;
          var nearest = 0;
          var best = Infinity;
          for (var i = 0; i < slides.length; i++) {
            var d = Math.abs((slides[i].offsetLeft - origin) - pos);
            if (d < best) { best = d; nearest = i; }
          }
          if (nearest !== index) paint(nearest);
        });
      }, { passive: true });

      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () { goTo(n); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
        else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
        else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
      });

      // Called by the variant picker when a finish has its own photograph.
      root.plyGallery = {
        goToMedia: function (mediaId) {
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return true; }
          }
          return false;
        }
      };

      paint(0);
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[name="id"]');
      // The price block sits ABOVE the form, not inside it. Scoping these to the form meant
      // they were always null, so a customer could pick Lungo at AED 4,820 and still read 3,830.
      var scope = form.closest('.pdp__info') || document;
      var priceEl = scope.querySelector('[data-price]');
      var cmpEl = scope.querySelector('[data-compare]');
      var btn = form.querySelector('[data-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;

      function selected() {
        return Array.prototype.map.call(form.querySelectorAll('[data-option-group]'), function (g) {
          var on = g.querySelector('[aria-checked="true"]');
          return on ? on.getAttribute('data-value') : null;
        });
      }

      function match(opts) {
        return variants.find(function (v) {
          return opts.every(function (o, i) { return o === null || v.options[i] === o; });
        });
      }

      function render(announce) {
        var v = match(selected());
        if (!v) return;
        if (idInput) idInput.value = v.id;

        if (priceEl) priceEl.textContent = v.price_formatted || money(v.price);
        if (cmpEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            cmpEl.textContent = v.compare_at_price_formatted || money(v.compare_at_price);
            cmpEl.removeAttribute('hidden');
          } else { cmpEl.setAttribute('hidden', ''); }
        }

        form.querySelectorAll('[data-option-label-value]').forEach(function (s) {
          var idx = parseInt(s.getAttribute('data-option-label-value'), 10);
          s.textContent = v.options[idx] || '';
        });

        if (btn) {
          if (v.available) {
            btn.removeAttribute('disabled');
            if (btnLabel) btnLabel.textContent = btn.getAttribute('data-label-add');
          } else {
            btn.setAttribute('disabled', '');
            if (btnLabel) btnLabel.textContent = btn.getAttribute('data-label-sold');
          }
        }

        // keep URL honest for sharing / analytics
        if (history.replaceState && v.id) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }

        // show the photograph of the finish they just picked, without reordering the gallery
        if (v.featured_image_id) {
          var g = document.querySelector('[data-gallery]');
          if (g && g.plyGallery) g.plyGallery.goToMedia(v.featured_image_id);
        }

        // anything that cares about price — the Tabby message, for one — listens for this
        if (announce !== false) {
          document.dispatchEvent(new CustomEvent('ply:variant:change', { detail: { variant: v } }));
        }
      }

      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        group.addEventListener('click', function (e) {
          var b = e.target.closest('[data-value]');
          if (!b) return;
          group.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
          b.setAttribute('aria-checked', 'true');
          render();
        });
      });

      render(false);
    });
  }

  /* ---------- quantity ---------- */
  function initQty() {
    document.querySelectorAll('.qty').forEach(function (w) {
      var input = w.querySelector('input');
      w.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- add to cart (ajax) ---------- */
  function initAddToCart() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!ROUTES.cartAdd) return; // fall back to normal POST
        e.preventDefault();
        var btn = form.querySelector('[data-add]');
        var label = btn ? btn.querySelector('span') : null;
        var prev = label ? label.textContent : '';
        if (btn) { btn.setAttribute('disabled', ''); if (label) label.textContent = btn.getAttribute('data-label-adding') || 'Adding…'; }

        fetch(ROUTES.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
            return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (btn) { btn.removeAttribute('disabled'); if (label) label.textContent = btn.getAttribute('data-label-added') || 'Added'; }
            setTimeout(function () { if (label) label.textContent = prev; }, 1900);
            // the cart drawer (v5.js) listens for this and opens with the real cart
            var fd = new FormData(form);
            document.dispatchEvent(new CustomEvent('ply:cart:added', { detail: { cart: cart, variantId: fd.get('id') } }));
          })
          .catch(function (err) {
            if (btn) { btn.removeAttribute('disabled'); if (label) label.textContent = prev; }
            var note = form.querySelector('[data-form-error]');
            if (note) { note.textContent = err.message; note.removeAttribute('hidden'); }
          });
      });
    });
  }

  /* ---------- cart line quantity ---------- */
  function initCartLines() {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      var line = input.getAttribute('data-line-qty');
      fetch(ROUTES.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
      }).then(function () { window.location.reload(); });
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (!rm) return;
      e.preventDefault();
      fetch(ROUTES.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(rm.getAttribute('data-line-remove'), 10), quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  }

  /* ---------- product recommendations ----------
     Shopify picks them, we fetch after paint so they never hold the page up. */
  function initRecommendations() {
    var host = document.querySelector('[data-recommendations]');
    if (!host) return;
    var url = host.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('section');
        if (!section) return;
        host.innerHTML = section.outerHTML;
        initReveal();
      })
      .catch(function () { /* recommendations are a nicety, never an error the customer sees */ });
  }

  /* ---------- facet dropdowns ---------- */
  function initFacets() {
    function closeAll() {
      document.querySelectorAll('.facet__panel').forEach(function (p) { p.setAttribute('hidden', ''); });
      document.querySelectorAll('.facet__toggle').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    document.querySelectorAll('.facet').forEach(function (f) {
      var toggle = f.querySelector('.facet__toggle');
      var panel = f.querySelector('.facet__panel');
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !panel.hasAttribute('hidden');
        closeAll();
        if (isOpen) return;
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    var form = document.getElementById('FacetForm');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || REDUCED) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initDrawer();
    initGallery();
    initVariants();
    initQty();
    initAddToCart();
    initCartLines();
    initFacets();
    initReveal();
    initRecommendations();
  });
})();
